import { css } from "glamor";
import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import { colors, spacing } from "../library/theme";

const FIXED_SIZE = 38;
const buttonStyle = (buttonColor = colors.greyLight) => {
  const color =
    buttonColor == colors.greyLight ? colors.greyShadow : colors.greyClear;

  return {
    color,
    width: FIXED_SIZE,
    height: FIXED_SIZE,
    padding: 0,
    borderRadius: "50%",
    background: buttonColor,
  };
};

const wrapperStyle = {
  position: "relative",
  display: "inline-block",
  marginRight: spacing.xxs,
  marginBottom: spacing.xxs,
};

const lockBadgeStyle = {
  position: "absolute",
  bottom: 0,
  right: -2,
  pointerEvents: "none",
};

const activeClass = css({
  border: `3px solid ${colors.primary} !important`,
  ".ui.button:disabled": { opacity: "1 !important" },
});

export default function LessonQuestionPaginationItem({
  index,
  currentIndex,
  goToIndexHandler,
  answered,
  displayIndex,
  isLocked,
}) {
  const buttonColor = answered?.value ? colors.correct : colors.wrong;
  const isActive = currentIndex === index;
  const displayNumber = displayIndex || String(index + 1);

  const inner = (
    <div style={wrapperStyle}>
      <Button
        className={isActive && activeClass.toString()}
        style={buttonStyle(answered ? buttonColor : undefined)}
        onClick={goToIndexHandler}
        disabled={isActive}
        circular
      >
        {displayNumber}
      </Button>
      {isLocked && (
        <div style={lockBadgeStyle}>
          <Icon name="lock" style={{ fontSize: 10, margin: 0, color: colors.greyShadow }} />
        </div>
      )}
    </div>
  );

  if (isLocked) {
    return (
      <Popup
        content="Responda a etapa anterior para desbloquear esta questão"
        trigger={inner}
        size="mini"
        position="top center"
      />
    );
  }

  return inner;
}
